export default __webpack_public_path__ + "static/media/fantasy.e4567e9d.svg";